import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
    routes: [{
            path: '/admin',
            name: 'admin',
            component: () =>
                import ("./views/GenericPage.vue"),
            meta: {
                pageTitle: 'Impostazioni'
            },
            children: [
                /*{
                    path: '/manageDb',
                    name: 'manageDb',
                    component: () =>
                        import ("./views/ManageDb.vue"),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'Sincro dati'
                    }
                },*/
                {
                    path: '/idempiereSynchro',
                    name: 'idempieresynchro',
                    component: () =>
                        import ("./views/idempiereSynchro.vue"),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'Sincro Idempiere'
                    }
                },
                {
                    path: '/mastercalSynchro',
                    name: 'mastercalsynchro',
                    component: () =>
                        import ("./views/mastercalSynchro.vue"),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'Sincro Metrycal'
                    }
                },
                {
                    path: 'master',
                    name: '',
                    component: () =>
                        import ("./views/GenericPage.vue"),
                    meta: {
                        pageTitle: 'Master'
                    },
                    children: [{
                            path: '',
                            name: 'listMaster',
                            component: () =>
                                import ("./views/admin/MasterList.vue"),
                            meta: {
                                requiresAuth: true,
                                pageTitle: ''
                            }

                        },
                        {
                            path: 'edit',
                            name: 'editMaster',
                            component: () =>
                                import ("./views/admin/MasterEdit_new.vue"),
                            //props: (route) => ({ m_id: route.query.m_id, source: route.query.source, create: route.query.create }),
                            props: (route) => ({ m_id: route.query.m_id, clone: (route.query.clone === 'true'), preview: (route.query.preview === 'true') }),
                            meta: {
                                requiresAuth: true,
                                pageTitle: 'Edit'
                            }
                        }

                    ],
                },
                {
                    path: 'category',
                    name: '',
                    component: () =>
                        import ("./views/GenericPage.vue"),
                    meta: {
                        pageTitle: 'Set di prove'
                    },
                    children: [{
                            path: '',
                            name: 'listCategory',
                            component: () =>
                                import ("./views/admin/CategoryList.vue"),
                            meta: {
                                requiresAuth: true,
                                pageTitle: ''
                            }

                        },
                        {
                            path: 'edit',
                            name: 'editCategory',
                            component: () =>
                                import ("./views/admin/CategoryEdit.vue"),
                            //props: (route) => ({ m_id: route.query.m_id, source: route.query.source, create: route.query.create }),
                            props: (route) => ({ c_id: route.query.c_id, clone: (route.query.clone === 'true'), preview: (route.query.preview === 'true') }),
                            meta: {
                                requiresAuth: true,
                                pageTitle: 'Edit'
                            }
                        },
                        {
                            path: 'view',
                            name: 'viewCategory',
                            component: () =>
                                import ("./views/admin/CategoryEdit.vue"),
                            //props: (route) => ({ m_id: route.query.m_id, source: route.query.source, create: route.query.create }),
                            props: (route) => ({ c_id: route.query.c_id, clone: (route.query.clone === 'true'), preview: (route.query.preview === 'true') }),
                            meta: {
                                requiresAuth: true,
                                pageTitle: 'Dettagli'
                            }
                        }
                    ],
                },
                {
                    path: 'procedure',
                    name: '',
                    component: () =>
                        import ("./views/GenericPage.vue"),
                    meta: {
                        pageTitle: 'Procedure'
                    },

                    children: [{
                            path: '',
                            name: 'listProcedure',
                            component: () =>
                                import ("./views/admin/ProcedureList.vue"),
                            meta: {
                                requiresAuth: true,
                                pageTitle: ''
                            }

                        },
                        {
                            path: 'edit',
                            name: 'editProcedure',
                            component: () =>
                                import ("./views/admin/Procedure_edit.vue"),
                            //props: (route) => ({ m_id: route.query.m_id, source: route.query.source, create: route.query.create }),
                            props: (route) => ({ p_id: route.query.p_id, clone: (route.query.clone === 'true'), preview: (route.query.preview === 'true') }),
                            meta: {
                                requiresAuth: true,
                                pageTitle: 'Edit'
                            }
                        }
                    ],
                },
                {
                    path: 'primaries',
                    name: '',
                    component: () =>
                        import ("./views/GenericPage.vue"),
                    meta: {
                        pageTitle: 'Masse di lavoro'
                    },
                    children: [{
                            path: '',
                            name: 'primariesList',
                            component: () =>
                                import ("./views/admin/PrimaryList.vue"),
                            meta: {
                                requiresAuth: true,
                                pageTitle: ''
                            },
                        },
                        {
                            path: 'primaryEdit',
                            name: 'primaryEdit',
                            component: () =>
                                import ("./views/instruments/InstrumentEdit_new.vue"),
                            props: (route) => ({ client_id: route.query.client_id, back: route.query.back, instrument_id: route.query.instrument_id, lock_client: (route.query.lock_client === 'true'), clone: (route.query.clone === 'true') }),
                            meta: {
                                requiresAuth: true,
                                pageTitle: 'Edit'
                            }
                        },
                        {
                            path: 'primaryDetails',
                            name: 'primaryDetails',
                            component: () =>
                                import ("./views/instruments/PrimaryDetails.vue"),
                            props: (route) => ({ i_id: route.query.i_id, back: route.query.back }),
                            meta: {
                                requiresAuth: true,
                                pageTitle: 'Dettaglio'
                            },
                        },
                    ]
                },
                {
                    path: 'users',
                    name: 'users',
                    component: () =>
                        import ("./views/admin/Users.vue"),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'Utenti'
                    }
                },
                
                {
                    path: 'config',
                    name: 'config',
                    component: () =>
                        import ("./views/admin/ConfigPage.vue"),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'Configurazione'
                    }
                },
                {
                    path: 'orgs',
                    name: '',
                    component: () =>
                        import ("./views/GenericPage.vue"),
                    meta: {
                        pageTitle: 'Enti'
                    },
                    children: [{
                            path: '',
                            name: 'orgsList',
                            component: () =>
                                import ("./views/admin/Orgs.vue"),
                            meta: {
                                requiresAuth: true,
                                pageTitle: ''
                            },
                        },
                        {
                            path: 'details',
                            name: 'orgDetails',
                            component: () =>
                                import ("./views/admin/OrgDetails_new"),
                            props: (route) => ({ org_id: route.query.org_id, back: route.query.back }),
                            meta: {
                                requiresAuth: true,
                                pageTitle: 'Dettaglio'
                            }
                        }
                    ],
                },
                {
                    path: 'formulas',
                    name: 'formulas',
                    component: () =>
                        import ("./views/admin/TestFormulas.vue"),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'Formule'
                    }
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: () =>
                import ("./views/Login"),
            props: (route) => ({ error: route.query.error }),
            meta: {
                hideForAuth: true,
                pageTitle: 'Login'
            }
        },
        {
            path: '/recovery',
            name: 'recovery',
            component: () =>
                import ("./views/PasswordRecovery"),
            meta: {
                hideForAuth: true,
                pageTitle: 'Recupero password'
            }
        },
        {
            path: '/operations',
            name: '',
            component: () =>
                import ("./views/GenericPage.vue"),
            meta: {
                pageTitle: 'Interventi'
            },
            children: [{
                    path: '',
                    name: 'operationsList',
                    component: () =>
                        import ("./views/operations/OperationList_new.vue"),
                    meta: {
                        requiresAuth: true,
                        pageTitle: ''
                    }
                }, {
                    path: 'edit',
                    name: 'edit',
                    component: () =>
                        import ("./views/operations/OperationEdit_multiple.vue"),
                    props: (route) => ({
                        client_id: route.query.client_id,
                        location_id: route.query.location_id,
                        department_id: route.query.department_id,
                        instr_ids: route.query.instr_ids,
                        back: route.query.back
                    }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'Edit'
                    }
                },

                {
                    path: 'details',
                    name: 'details',
                    component: () =>
                        import ("./views/operations/OperationDetails.vue"),
                    props: (route) => ({ op_id: route.query.op_id, back: route.query.back }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'Dettaglio'
                    }
                }
            ]
        },
        {
            path: '/instruments',
            name: '',
            component: () =>
                import ("./views/GenericPage.vue"),
            meta: {
                pageTitle: 'Strumenti'
            },
            children: [{
                    path: '',
                    name: 'listInstr',
                    component: () =>
                        import ("./views/instruments/InstrumentList_new.vue"),
                    props: (route) => ({ back: route.query.back, open_qr_search: (route.query.open_qr_search === 'true') }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: ''
                    }
                },
                {
                    path: 'edit',
                    name: 'editInstrument',
                    component: () =>
                        import ("./views/instruments/InstrumentEdit_new.vue"),
                    props: (route) => ({ client_id: route.query.client_id, back: route.query.back, instrument_id: route.query.instrument_id, lock_client: (route.query.lock_client === 'true'), clone: (route.query.clone === 'true') }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'Edit'
                    }
                },
                {
                    path: 'details',
                    name: 'detailsInstr',
                    component: () =>
                        import ("./views/instruments/InstrumentDetails.vue"),
                    props: (route) => ({ i_id: route.query.i_id, lock_client: (route.query.lock_client === 'true'), back: route.query.back }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'Dettaglio'
                    }
                },
                {
                    path: 'dismissed',
                    name: 'listDismissedInstr',
                    component: () =>
                        import ("./views/instruments/DismissedInstrumentList.vue"),
                    props: (route) => ({ back: route.query.back, client_id: route.query.client_id }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: ''
                    }
                },
            ]
        },
        {
            path: '/clients',
            name: '',
            component: () =>
                import ("./views/GenericPage.vue"),
            meta: {
                pageTitle: 'Clienti'
            },
            children: [{
                    path: '',
                    name: 'clientList',
                    component: () =>
                        import ("./views/clients/ClientList.vue"),
                    meta: {
                        requiresAuth: true,
                        pageTitle: ''
                    }
                },
                {
                    path: 'edit',
                    name: 'clientEdit',
                    component: () =>
                        import ("./views/clients/ClientEdit_new.vue"),
                    props: (route) => ({ client_id: route.query.client_id, back: route.query.back }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'Edit'
                    }
                },
                {
                    path: 'details',
                    name: 'clientDetails',
                    component: () =>
                        import ("./views/clients/ClientDetails.vue"),
                    props: (route) => ({ client_id: route.query.client_id, back: route.query.back }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'Dettaglio'
                    }
                }
            ]
        },
        {
            path: '/reports',
            name: 'reports',
            component: () =>
                import ("./views/GenericPage.vue"),
            meta: {
                pageTitle: 'Report'
            },
            children: [{
                    path: 'list',
                    name: 'reportList',
                    component: () =>
                        import ("./views/reports/ReportList2.vue"),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'tutti'
                    }
                },
                {
                    path: 'new',
                    name: 'reportNew',
                    component: () =>
                        import ("./views/reports/ReportList2.vue"),
                    props: (route) => ({ filter_status: ['new', 'measuring'], back: route.query.back }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'in corso'
                    }
                },
                {
                    path: 'completed',
                    name: 'reportCompleted',
                    component: () =>
                        import ("./views/reports/ReportList2.vue"),
                    props: (route) => ({ filter_status: ['completed'], back: route.query.back }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'in corso'
                    }
                },
                {
                    path: 'pdf_gen',
                    name: 'reportPdfGeneration',
                    component: () =>
                        import ("./views/reports/ReportPdfGeneration_new.vue"),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'generazione PDF'
                    }
                },
                {
                    path: 'reviews',
                    name: 'reportReview',
                    component: () =>
                        import ("./views/reports/ReportReview_new.vue"),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'in attesa di riesame'
                    }
                },
                {
                    path: 'revising',
                    name: 'reportRevising',
                    component: () =>
                        import ("./views/reports/ReportList2.vue"),
                    props: (route) => ({ filter_status: ['revising'], back: route.query.back }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'riesame fallito'
                    }
                },
                {
                    path: 'revised',
                    name: 'reportRevised',
                    component: () =>
                        import ("./views/reports/ReportList2.vue"),
                    props: (route) => ({ filter_status: ['revised'], back: route.query.back }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'revisionati'
                    }
                },
                {
                    path: 'ready',
                    name: 'reportReady',
                    component: () =>
                        import ("./views/reports/ReportListReadySigned.vue"),
                    props: (route) => ({ filter_status: ['ready', 'ready_failed'], back: route.query.back }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'completati'
                    }
                },
                {
                    path: 'readyFailed',
                    name: 'reportReadyFailed',
                    component: () =>
                        import ("./views/reports/ReportList2.vue"),
                    props: (route) => ({ filter_status: ['ready_failed'], back: route.query.back }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'conclusi'
                    }
                },
                {
                    path: 'signed',
                    name: 'reportSigned',
                    component: () =>
                        import ("./views/reports/ReportListReadySigned.vue"),
                    props: (route) => ({ filter_status: ['signed'], back: route.query.back }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'firmati'
                    }
                },
                {
                    path: 'edit',
                    name: 'reportEdit',
                    component: () =>
                        import ("./views/reports/ReportEdit_new.vue"),
                    props: (route) => ({ report_id: route.query.report_id, operation_id: route.query.operation_id, instrument_id: route.query.instrument_id, op_type: route.query.op_type, op_date: route.query.op_date, back: route.query.back }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'Edit'
                    }
                },
                {
                    path: 'details',
                    name: 'reportDetails',
                    component: () =>
                        import ("./views/reports/ReportDetails.vue"),
                    props: (route) => ({ report_id: route.query.report_id, review: false, back: route.query.back }),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'Dettaglio'
                    }
                },
                {
                    path: 'review',
                    name: 'reportDet2',
                    component: () =>
                        import ("./views/reports/ReportDetails.vue"),
                    props: (route) => ({ report_id: route.query.report_id, review: true, back: route.query.back }),
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'report_management',
                    name: 'report_management',
                    component: () =>
                        import ("./views/reports/ReportCodeManagement.vue"),
                    meta: {
                        requiresAuth: true,
                        pageTitle: 'gestione'
                    }
                }
            ]
        },
        {
            path: '/home',
            name: 'home',
            component: () =>
                import ("./views/Home.vue"),
            meta: {
                requiresAuth: true,
                pageTitle: 'Home'
            },
            alias: '/'
        },
        /*{
            path: '/viewPdf',
            name: 'viewPdf',
            component: () =>
                import ("./views/pdf_page.vue"),
            props: (route) => ({ pdf_source: route.query.pdf_source, filename: route.query.filename, back: route.query.back }),
            meta: {
                requiresAuth: true,
                pageTitle: 'PDF'
            }
        },*/
        {
            path: '/mysandbox',
            name: 'mysandbox',
            component: () =>
                import ("./views/MySandbox.vue")
        },
        {
            path: '/ffsandbox',
            name: 'ffsandbox',
            component: () =>
                import ("./views/FFSandbox.vue")
        },

        
    ]
})


router.beforeEach((to, from, next) => {
    let token = localStorage.getItem("__jwt");
    if (token) {
        if (to.matched.some(record => record.meta.hideForAuth)) {
            next({ path: '/' })
        } else {
            next()
        }
    } else {
        if (to.matched.some(record => record.meta.requiresAuth)) {
            next("/login")
        } else {
            next()
        }
    }
})


export default router